import ComponentCode from './ComponentCode';

export default ComponentCode;
